import { de } from './de'
import { en } from './en'

export const messages = {
  de,
  en
}

export default messages
